function showmore() {
  document.querySelectorAll(".js-showmore-button").forEach((button) => {
    button.style.cursor = "pointer";
    button.addEventListener("click", () => {
      button.style.display = "none";
      const showmore = button.closest(".js-showmore");
      if (showmore) {
        showmore.style.height = "auto";
        showmore.classList.forEach((className) => {
          if (className.endsWith("--hide")) {
            showmore.classList.remove(className);
          }
        });
      }
    });
  });
}

export { showmore };
